// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ExtEnrollmentHybridEnrollmentHistoryModel } from './extEnrollmentHybridEnrollmentHistoryModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExtEnrollmentHybridPatientLookupResultModel {
    'patientId'?: string;
    'memberNumber'?: string;
    'enrollments': Array<ExtEnrollmentHybridEnrollmentHistoryModel>;
    'medicalPayerId'?: string;
    'medicalMemberNumber'?: string;
    'medicalGroupNumber'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtEnrollmentHybridPatientLookupResultModel>> = [
        {
            "name":     "patientId",
            "baseName": "patientId",
            "type":     "string"
        },
        {
            "name":     "memberNumber",
            "baseName": "memberNumber",
            "type":     "string"
        },
        {
            "name":     "enrollments",
            "baseName": "enrollments",
            "type":     "Array<ExtEnrollmentHybridEnrollmentHistoryModel>"
        },
        {
            "name":     "medicalPayerId",
            "baseName": "medicalPayerId",
            "type":     "string"
        },
        {
            "name":     "medicalMemberNumber",
            "baseName": "medicalMemberNumber",
            "type":     "string"
        },
        {
            "name":     "medicalGroupNumber",
            "baseName": "medicalGroupNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ExtEnrollmentHybridPatientLookupResultModel.attributeTypeMap;
    }
}
